import { render, staticRenderFns } from "./PlayerPendingAddDataInputFollowingLink.vue?vue&type=template&id=da281bd4&"
import script from "./PlayerPendingAddDataInputFollowingLink.vue?vue&type=script&lang=js&"
export * from "./PlayerPendingAddDataInputFollowingLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports